import {useParams} from "react-router";
import {getBuyer} from "../../api/Api";
import {useState, useEffect} from 'react';
import {BuyerProfile} from "./BuyerProfile";

export const BuyerView = ({onApiFail, refresh, onRefresh, props}) => {
    const [buyer, setBuyer] = useState(undefined);
    const params = useParams();
    const buyerId = params.buyerId;


    useEffect(() => {
        if (buyerId === undefined) {
            return;
        }
        getBuyer(buyerId).then(result => {
            setBuyer(result);

        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }, [buyerId, refresh, onApiFail]);

    if (!buyerId) {
        return <div />
    }

    return <BuyerProfile buyer={buyer} refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
}